import {
  USER_STATUS_BASIC,
  USER_STATUS_PARKED,
  USER_STATUS_PREMIUM,
  USER_STATUS_STARTER,
} from './User'

export const CHF_CURRENCY = 'CHF'
export const EUR_CURRENCY = 'EUR'
export const USD_CURRENCY = 'USD'

const CHF_SYMBOL = CHF_CURRENCY
const EUR_SYMBOL = '€'
const USD_SYMBOL = USD_CURRENCY

const DISCOUNT = 0

const PRICE_BASIC_CHF = calculatePrice(9.9)
const PRICE_STARTER_CHF = calculatePrice(39)
const PRICE_PREMIUM_CHF = calculatePrice(79)

const PRICE_BASIC_EUR = calculatePrice(9)
const PRICE_STARTER_EUR = calculatePrice(36)
const PRICE_PREMIUM_EUR = calculatePrice(72.5)

const PRICE_BASIC_USD = calculatePrice(9.9)
const PRICE_STARTER_USD = calculatePrice(39)
const PRICE_PREMIUM_USD = calculatePrice(79)

const PARKING_PRICE_BASIC_CHF = 1
const PARKING_PRICE_STARTER_CHF = 3.9
const PARKING_PRICE_PREMIUM_CHF = 7.9

const PARKING_PRICE_BASIC_EUR = 0.99
const PARKING_PRICE_STARTER_EUR = 3.25
const PARKING_PRICE_PREMIUM_EUR = 7.25

const PARKING_PRICE_BASIC_USD = 1
const PARKING_PRICE_STARTER_USD = 3.9
const PARKING_PRICE_PREMIUM_USD = 7.9

export const ANNUAL_PRICE_BASIC_CHF = calculatePrice(11880)
export const ANNUAL_PRICE_STARTER_CHF = calculatePrice(46800)
export const ANNUAL_PRICE_PREMIUM_CHF = calculatePrice(94800)

export const ANNUAL_PRICE_BASIC_EUR = calculatePrice(10800)
export const ANNUAL_PRICE_STARTER_EUR = calculatePrice(43200)
export const ANNUAL_PRICE_PREMIUM_EUR = calculatePrice(87000)

export const ANNUAL_PRICE_BASIC_USD = calculatePrice(11880)
export const ANNUAL_PRICE_STARTER_USD = calculatePrice(46800)
export const ANNUAL_PRICE_PREMIUM_USD = calculatePrice(94800)

function calculatePrice(value) {
  return round(value * (1 - DISCOUNT), 0.25)
}

function round(value, step) {
  step || (step = 1.0)
  const inv = 1.0 / step
  return Math.round(value * inv) / inv
}

export class Pricing {
  static annualPriceWithCurrentCurrency(status, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${CHF_SYMBOL} ${ANNUAL_PRICE_BASIC_CHF / 100}`
          case USER_STATUS_STARTER:
            return `${CHF_SYMBOL} ${ANNUAL_PRICE_STARTER_CHF / 100}`
          case USER_STATUS_PREMIUM:
            return `${CHF_SYMBOL} ${ANNUAL_PRICE_PREMIUM_CHF / 100}`
          default:
            return null
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${EUR_SYMBOL} ${ANNUAL_PRICE_BASIC_EUR / 100}`
          case USER_STATUS_STARTER:
            return `${EUR_SYMBOL} ${ANNUAL_PRICE_STARTER_EUR / 100}`
          case USER_STATUS_PREMIUM:
            return `${EUR_SYMBOL} ${ANNUAL_PRICE_PREMIUM_EUR / 100}`
          default:
            return null
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${USD_SYMBOL} ${ANNUAL_PRICE_BASIC_USD / 100}`
          case USER_STATUS_STARTER:
            return `${USD_SYMBOL} ${ANNUAL_PRICE_STARTER_USD / 100}`
          case USER_STATUS_PREMIUM:
            return `${USD_SYMBOL} ${ANNUAL_PRICE_PREMIUM_USD / 100}`
          default:
            return null
        }
    }
  }

  static upgradePriceWithCurrency(upgradePrice, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        return `${CHF_SYMBOL} ${upgradePrice / 100}`
      case EUR_CURRENCY:
        return `${EUR_SYMBOL} ${upgradePrice / 100}`
      default:
        return `${USD_SYMBOL} ${upgradePrice / 100}`
    }
  }

  static priceWithCurrentCurrency(status, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${CHF_SYMBOL} ${PRICE_BASIC_CHF}`
          case USER_STATUS_STARTER:
            return `${CHF_SYMBOL} ${PRICE_STARTER_CHF}`
          case USER_STATUS_PREMIUM:
            return `${CHF_SYMBOL} ${PRICE_PREMIUM_CHF}`
          default:
            return null
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${EUR_SYMBOL} ${PRICE_BASIC_EUR}`
          case USER_STATUS_STARTER:
            return `${EUR_SYMBOL} ${PRICE_STARTER_EUR}`
          case USER_STATUS_PREMIUM:
            return `${EUR_SYMBOL} ${PRICE_PREMIUM_EUR}`
          default:
            return null
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${USD_SYMBOL} ${PRICE_BASIC_USD}`
          case USER_STATUS_STARTER:
            return `${USD_SYMBOL} ${PRICE_STARTER_USD}`
          case USER_STATUS_PREMIUM:
            return `${USD_SYMBOL} ${PRICE_PREMIUM_USD}`
          default:
            return null
        }
    }
  }

  static parkingPriceWithCurrentCurrency(status, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${CHF_SYMBOL} ${PARKING_PRICE_BASIC_CHF}`
          case USER_STATUS_STARTER:
            return `${CHF_SYMBOL} ${PARKING_PRICE_STARTER_CHF}`
          case USER_STATUS_PREMIUM:
            return `${CHF_SYMBOL} ${PARKING_PRICE_PREMIUM_CHF}`
          default:
            return null
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${EUR_SYMBOL} ${PARKING_PRICE_BASIC_EUR}`
          case USER_STATUS_STARTER:
            return `${EUR_SYMBOL} ${PARKING_PRICE_STARTER_EUR}`
          case USER_STATUS_PREMIUM:
            return `${EUR_SYMBOL} ${PARKING_PRICE_PREMIUM_EUR}`
          default:
            return null
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return `${USD_SYMBOL} ${PARKING_PRICE_BASIC_USD}`
          case USER_STATUS_STARTER:
            return `${USD_SYMBOL} ${PARKING_PRICE_STARTER_USD}`
          case USER_STATUS_PREMIUM:
            return `${USD_SYMBOL} ${PARKING_PRICE_PREMIUM_USD}`
          default:
            return null
        }
    }
  }

  static parkingPrice(status, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return PARKING_PRICE_BASIC_CHF
          case USER_STATUS_STARTER:
            return PARKING_PRICE_STARTER_CHF
          case USER_STATUS_PREMIUM:
            return PARKING_PRICE_PREMIUM_CHF
          default:
            return null
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return PARKING_PRICE_BASIC_EUR
          case USER_STATUS_STARTER:
            return PARKING_PRICE_STARTER_EUR
          case USER_STATUS_PREMIUM:
            return PARKING_PRICE_PREMIUM_EUR
          default:
            return null
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return PARKING_PRICE_BASIC_USD
          case USER_STATUS_STARTER:
            return PARKING_PRICE_STARTER_USD
          case USER_STATUS_PREMIUM:
            return PARKING_PRICE_PREMIUM_USD
          default:
            return null
        }
    }
  }

  static annualPrice(status, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return ANNUAL_PRICE_BASIC_CHF
          case USER_STATUS_STARTER:
            return ANNUAL_PRICE_STARTER_CHF
          case USER_STATUS_PREMIUM:
            return ANNUAL_PRICE_PREMIUM_CHF
          default:
            return 0
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return ANNUAL_PRICE_BASIC_EUR
          case USER_STATUS_STARTER:
            return ANNUAL_PRICE_STARTER_EUR
          case USER_STATUS_PREMIUM:
            return ANNUAL_PRICE_PREMIUM_EUR
          default:
            return 0
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return ANNUAL_PRICE_BASIC_USD
          case USER_STATUS_STARTER:
            return ANNUAL_PRICE_STARTER_USD
          case USER_STATUS_PREMIUM:
            return ANNUAL_PRICE_PREMIUM_USD
          default:
            return 0
        }
    }
  }

  static planIdForCurrentCurrency(status, currency, fromStatus) {
    if (status === USER_STATUS_PARKED) {
      return Pricing.parkPlanIdForCurrentCurrency(fromStatus)
    }
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return 'plan_DVrxXIBEA6Olqf'
          case USER_STATUS_STARTER:
            return 'plan_DDtW1YwGRGjbw8'
          case USER_STATUS_PREMIUM:
            return 'plan_DDtaluRntY4L49'
          default:
            return null
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return 'plan_DVrwPkiTzygyRh'
          case USER_STATUS_STARTER:
            return 'plan_DDtXmImEQoiqMy'
          case USER_STATUS_PREMIUM:
            return 'plan_DDtbAcrqsj3Pbp'
          default:
            return null
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return 'plan_DVrwqefEsUcOTL'
          case USER_STATUS_STARTER:
            return 'plan_DDtXPrtakVJgPF'
          case USER_STATUS_PREMIUM:
            return 'plan_DDtbOqxxAF6nfJ'
          default:
            return null
        }
    }
  }

  static parkPlanIdForCurrentCurrency(status, currency) {
    switch (currency) {
      case CHF_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return 'plan_DEAF9vUFdJDrsc'
          case USER_STATUS_STARTER:
            return 'plan_DEADCFqU2lIqUw'
          case USER_STATUS_PREMIUM:
            return 'plan_DEAB72lSuXUE7m'
          default:
            return null
        }
      case EUR_CURRENCY:
        switch (status) {
          case USER_STATUS_BASIC:
            return 'plan_DEAHjGH3tO4bFR'
          case USER_STATUS_STARTER:
            return 'plan_DEADzzskq3bgJR'
          case USER_STATUS_PREMIUM:
            return 'plan_DEACUS2fFblYdW'
          default:
            return null
        }
      default:
        switch (status) {
          case USER_STATUS_BASIC:
            return 'plan_DEAFIPna4Ylklm'
          case USER_STATUS_STARTER:
            return 'plan_DEAEwYsqDqiPiD'
          case USER_STATUS_PREMIUM:
            return 'plan_DEACCKRfNeyc5J'
          default:
            return null
        }
    }
  }

  static planTypeFor(planId) {
    switch (planId) {
      case 'plan_DVrxXIBEA6Olqf':
      case 'plan_DVrwPkiTzygyRh':
      case 'plan_DVrwqefEsUcOTL':
        return USER_STATUS_BASIC
      case 'plan_DDtW1YwGRGjbw8':
      case 'plan_DDtXmImEQoiqMy':
      case 'plan_DDtXPrtakVJgPF':
        return USER_STATUS_STARTER
      case 'plan_DDtaluRntY4L49':
      case 'plan_DDtbAcrqsj3Pbp':
      case 'plan_DDtbOqxxAF6nfJ':
        return USER_STATUS_PREMIUM
      default:
        return null
    }
  }

  static currencySymbol(currency) {
    switch (currency) {
      case CHF_CURRENCY:
        return CHF_SYMBOL
      case EUR_CURRENCY:
        return EUR_SYMBOL
      default:
        return USD_SYMBOL
    }
  }
}
